// Map brand IDs to their image filenames
const brandImageMap: Record<string, string> = {
  'belle-tress': 'Belle_Tress',
  'amore': 'Amore_MHM_1',
  'ellen-wille': 'Ellen_Wille',
  'envy': 'Envy1',
  'estetica': 'Estetica1',
  'gabor': 'Gabor1',
  'jon-renau': 'Jon_Renau',
  'noriko': 'Noriko1',
  'raquel-welch': 'Raquel_Welch',
  'rene-of-paris': 'Rene_of_Paris',
  'tressallure': 'TressAllure1',
  'wigpro': 'WigPro1'
};

export const getBrandImageUrl = (brandId: string): string => {
  const filename = brandImageMap[brandId] || brandId;
  return `https://cdn.shopify.com/s/files/1/0753/9556/3833/files/${filename}.webp?v=1742066918`;
};